import React from 'react'

const ResetTokenSuccess = ({ children }) => {
  return <div className='align-center reset-token-succes'>{children}</div>
}

export default ResetTokenSuccess
